import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppAuth } from '../../contexts/AppAuthContext';

export const RequireAuth = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loading, isAdmin } = useAppAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <p className="text-slate-600">読み込み中...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/shipping" replace />;
  }

  return children;
};
